'use strict';

// var classicTvName = 'magcore-app-tv-classic',
//     tvName = 'magcore-app-tv';


// public interface
module.exports = {
    onSettingsInit: function ( config, callback ) {
        require('mag-gettext').load({
            name: core.environment.language,
            path: config.path + 'lang'
        }, function () {
            callback(null, {
                id: 'iface',
                name: 'Interface section',
                description: 'Interface section general description',
                options: [
                    // {
                    //     id: 'theme',
                    //     icon: 'theme-icon-interface',
                    //     name: gettext('Theme'),
                    //     description: 'Setting a theme (your interface appearance)',
                    //     render: config.api.renders.listItem,
                    //     saveImmediate: true,
                    //     parent: 'interface'
                    // },
                    require('./options/start.page')(config)
                    // {
                    //     id: 'metricSystem',
                    //     icon: 'theme-icon-cloud-sun',
                    //     name: gettext('Weather display format'),
                    //     description: gettext('Choosing a weather display format') + '<br>'
                    //         + gettext('Metric system (degrees Celsius ° C, m / s) or English system (degrees Fahrenheit ° F, miles / s)'),
                    //     render: config.api.renders.listItem,
                    //     saveImmediate: true,
                    //     parent: 'interface'
                    // },
                    // {
                    //     id: 'hdmiEventReaction',
                    //     icon: 'theme-icon-hdmi',
                    //     name: gettext('HDMI event reaction'),
                    //     description: gettext('Device response to HDMI cable disconnections'),
                    //     render: config.api.renders.listItem,
                    //     saveImmediate: true,
                    //     parent: 'interface'
                    // },
                    // {
                    //     id: 'screensaverInterval',
                    //     icon: 'theme-icon-screensaver-interval',
                    //     name: gettext('Screensaver interval'),
                    //     description: gettext('The duration of the device inactivity, upon which appears the splash screen'),
                    //     render: config.api.renders.listItem,
                    //     saveImmediate: true,
                    //     parent: 'interface'
                    // },
                    // {
                    //     id: 'clockInPlayer',
                    //     icon: 'theme-icon-clock-on-playback',
                    //     name: gettext('Clock during playing'),
                    //     description: gettext('Time display while watching a video'),
                    //     render: config.api.renders.listItem,
                    //     saveImmediate: true,
                    //     parent: 'interface'
                    // },
                    // {
                    //     id: 'ledBrightness',
                    //     icon: 'theme-icon-brightness',
                    //     name: gettext('LED brightness'),
                    //     description: gettext('Screen brightness in the set-top box operation mode'),
                    //     render: config.api.renders.listItem,
                    //     saveImmediate: true,
                    //     parent: 'interface'
                    // },
                    // {
                    //     id: 'ledBrightnessStandby',
                    //     icon: 'theme-icon-brightness-standby',
                    //     name: gettext('LED brightness (standby)'),
                    //     description: gettext('Screen brightness in standby mode'),
                    //     render: config.api.renders.listItem,
                    //     saveImmediate: true,
                    //     parent: 'interface'
                    // },
                    // {
                    //     id: 'rcModel',
                    //     icon: 'theme-icon-rc',
                    //     name: gettext('RC model'),
                    //     description: gettext('Choosing a remote control model'),
                    //     render: config.api.renders.listItem,
                    //     saveImmediate: true,
                    //     parent: 'interface'
                    // },
                    // {
                    //     id: 'screensaver',
                    //     icon: 'theme-icon-screensaver',
                    //     name: gettext('Screensaver'),
                    //     description: gettext('Choosing a splash Screensaver'),
                    //     render: config.api.renders.listItem,
                    //     saveImmediate: true,
                    //     parent: 'interface'
                    // }
                ]
            });
        });
    },
    onInit: function ( config, callback ) {
        var daemon = new (require('cjs-emitter'))();

        // daemon.addListener('system:start', function () {
        //     var classicTv = core.packageMap[classicTvName],
        //         tv = core.packageMap[tvName],
        //         homeApp;

        //     homeApp = config.storage.getItem('homeApp');
        //     console.log('11111111111111111111111111');
        //     console.log('homeApp ' + homeApp);
        //     console.log(JSON.stringify(['backend', window.core.backend]));

        //     if ( window.core.backend ) {
        //         window.core.backend.addListener('ready', function () {
        //             console.log(JSON.stringify(['show_after_loading', window.core.backend.settings.show_after_loading]));
        //             if ( window.core.backend.settings.show_after_loading === 'last_channel' ) {
        //                 if ( homeApp ) {
        //                     // settings exsits
        //                     if ( homeApp === 'last_channel' ) {
        //                         // confirm(1);
        //                         if ( classicTv ) {
        //                             // confirm(2);
        //                             config.storage.setItem('homeApp', classicTv.packageName);
        //                             console.log(JSON.stringify(['homeApp', classicTv.packageName]));
        //                             window.core.taskManager.setHomeApp(classicTv);
        //                         } else if ( tv ) {
        //                             // confirm(3);
        //                             config.storage.setItem('homeApp', tv.packageName);
        //                             console.log(JSON.stringify(['homeApp', tv.packageName]));
        //                             window.core.taskManager.setHomeApp(tv);
        //                         }
        //                     } else if ( homeApp === tvName && tv ) {
        //                         // confirm(4);
        //                         // settings saved to TV
        //                         config.storage.setItem('homeApp', tv.packageName);
        //                         console.log(JSON.stringify(['homeApp', tv.packageName]));
        //                         window.core.taskManager.setHomeApp(tv);
        //                     } else if ( homeApp === classicTvName && classicTv ) {
        //                         // confirm(5);
        //                         // settings saved to classic TV
        //                         config.storage.setItem('homeApp', classicTv.packageName);
        //                         console.log(JSON.stringify(['homeApp', classicTv.packageName]));
        //                         window.core.taskManager.setHomeApp(classicTv);
        //                     } else if ( homeApp === tvName && !tv && classicTv ) {
        //                         // confirm(4);
        //                         // classic TV exists, but settings saved to TV
        //                         config.storage.setItem('homeApp', classicTv.packageName);
        //                         console.log(JSON.stringify(['homeApp', classicTv.packageName]));
        //                         window.core.taskManager.setHomeApp(classicTv);
        //                     } else if ( homeApp === classicTvName && !classicTv && tv ) {
        //                         // confirm(5);
        //                         // TV exists, settings saved to classic TV
        //                         config.storage.setItem('homeApp', tv.packageName);
        //                         console.log(JSON.stringify(['homeApp', tv.packageName]));
        //                         window.core.taskManager.setHomeApp(tv);
        //                     } else if ( tv && classicTv ) {
        //                         // confirm(6);
        //                         window.core.taskManager.setHomeApp(classicTv);
        //                         console.log(JSON.stringify(['homeApp', classicTv.packageName]));
        //                     } else if ( window.core.packageMap[homeApp] ) {
        //                         // confirm(7);
        //                         console.log(JSON.stringify(['homeApp', homeApp]));
        //                         window.core.taskManager.setHomeApp(window.core.packageMap[homeApp]);
        //                     }
        //                 } else if ( classicTv ) {
        //                     // new start
        //                     // confirm(7);
        //                     config.storage.setItem('homeApp', classicTvName);
        //                     console.log(JSON.stringify(['homeApp', classicTvName]));

        //                     window.core.taskManager.setHomeApp(classicTv);
        //                 } else if ( tv ) {
        //                     // new start without classic TV
        //                     // confirm(8);
        //                     config.storage.setItem('homeApp', tvName);
        //                     console.log(JSON.stringify(['homeApp', tvName]));

        //                     window.core.taskManager.setHomeApp(tv);
        //                 }
        //             }
        //         });
        //     } else if ( window.core.packageMap[homeApp] ) {
        //         console.log(JSON.stringify(['homeApp', homeApp]));
        //         window.core.taskManager.setHomeApp(window.core.packageMap[homeApp]);
        //     }
        // });

        callback(null, daemon);
    }
};
